module.exports = "h1{margin-bottom:30px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/apps/admin/apps.admin.component.sass
// module id = ./src/app/modules/apps/admin/apps.admin.component.sass
// module chunks = main